module.exports = __webpack_public_path__ + "img/transitions-xtractive.e43ba99b.svg";